import { render } from "./RegisterAttendee.vue?vue&type=template&id=aa21f896&scoped=true"
import script from "./RegisterAttendee.vue?vue&type=script&lang=js"
export * from "./RegisterAttendee.vue?vue&type=script&lang=js"

import "./RegisterAttendee.vue?vue&type=style&index=0&id=aa21f896&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa21f896"]])

export default __exports__